import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NavController } from "@ionic/angular";
import { AuthService } from "src/app/_services/auth.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";
import { PusherService } from "src/app/_services/pusher.service";
import { NavigationService } from "src/app/_services/navigation-service.service";
@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.page.html",
  styleUrls: ["./forgot-password.page.scss"],
})
export class ForgotPasswordPage implements OnInit {
  resetPasswordForm!: FormGroup;
  email: string = "";
  submitted = false;
  isLoading = false;
  textType = "password";
  textTypeConfirmPw = "password";
  textTypeNewMdp = "password";

  constructor(
    private fb: FormBuilder,
    private navController: NavController,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private pusherService: PusherService,
    private navigationService: NavigationService
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.getEmail();
  }

  get f() {
    return this.resetPasswordForm.controls;
  }
  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors["mustMatch"]) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
  initForm() {
    this.resetPasswordForm = this.fb.group(
      {
        new_password: ["", [Validators.required, Validators.minLength(6)]],
        confirm_password: ["", [Validators.required, Validators.minLength(6)]],
      },
      {
        validator: this.MustMatch("new_password", "confirm_password"),
      }
    );
  }

  getEmail() {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state as { email: string; token: string };
    this.email = state?.email;
  }
  togglePasswordVisibility(event: any) {
    switch (event) {
      case "textType":
        this.textType = this.textType === "text" ? "password" : "text";
        break;
      case "textTypeNewMdp":
        this.textTypeNewMdp =
          this.textTypeNewMdp === "text" ? "password" : "text";

        break;
      case "textTypeConfirmPw":
        this.textTypeConfirmPw =
          this.textTypeConfirmPw === "text" ? "password" : "text";
        break;
      default:
        break;
    }
  }
  removeError() {
    this.submitted = false;
  }
  submitForm() {
    this.submitted = true;
    this.isLoading = true;
    if (this.resetPasswordForm.valid) {
      const payload = {
        email: this.email,
        password: this.f["new_password"].value,
      };
      this.authService.resetPassword(payload).subscribe({
        next: (res: any) => {
          this.isLoading = false;
          const response = res.body;
          const token = response.access_token;
          const user = response.user;
          const refresh = response.refresh_token;
          this.localStorageService.saveAuthDataFromLogin(
            token,
            user,
            user.roles[0],
            refresh
          );
          this.pusherService.auth();
          setTimeout(() => {
            this.pusherService.subscribeToDiscussionChannel();
            this.pusherService.subscribeToRoleChannel();
            this.router.navigate(["/"]);
          }, 1000);
        },
        error: (err: any) => {
          this.isLoading = false
        }
      }

      );
    } else {
      this.isLoading = false;
    }
  }

  backto() {
      setTimeout(() => {
      this.navigationService.goToPreviousPage();
    }, 100);
  }
}
